<template>
  <div :class="['expedition-log', { fullscreen: props.fullscreen }]" @click="emit('click')">
    <div class="expedition-log-holder">
      <UIHalloweenLogEntry
        v-for="(log, index) in logs"
        :key="log.uniqueEventIndex"
        :expedition-id="expeditionId"
        :log
        :log-index="index"
        :logs-count="logs?.length || 0"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import UIHalloweenLogEntry from '~/components/Halloween/ui/UIHalloweenLogEntry.vue';
import type { ExpeditionLog } from '~/types/halloween/expedition';

const props = defineProps<{ logs?: ExpeditionLog[]; fullscreen?: boolean; expeditionId: number }>();
const logs = computed(() => props.logs);
const emit = defineEmits<{
  (e: 'click'): void;
}>();
</script>
<style scoped>
.expedition-log {
  position: absolute;
  display: block;
  overflow: hidden;
  overflow-y: auto;

  width: 34%;
  height: 28%;

  top: 100px;
  left: 24px;

  box-sizing: border-box;
  background: rgba(16, 43, 54, 0.5);
  border: 1px solid #10364a;
  backdrop-filter: blur(50px) brightness(0.7);
  cursor: pointer;
  border-radius: 10px;

  z-index: 100;
  transition: all 0.3s;

  @media screen and (max-width: 640px) {
    left: 0;
  }
}

.expedition-log:not(.fullscreen) {
  @media screen and (max-width: 640px) {
    width: 100%;
    height: calc(50vh - 180px);
    top: 60vh;
  }
}

.expedition-log.fullscreen {
  width: 100%;
  height: calc(100% - 210px);
  top: 80px;
  left: 0;
}

.expedition-log-holder {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  width: 100%;
  height: fit-content;
}
</style>
